const POMODORO_STATUS = {
  INITIAL: 'INITIAL',
  PROGRESS: 'PROGRESS',
  PAUSE: 'PAUSE',
}

export { POMODORO_STATUS }
